import { Button } from '@mui/material'
import { signIn } from 'next-auth/react'
import Image from 'next/image'
import React, { useState } from 'react'

export const YandexAuthButton = ({ children = 'Войти с Яндекс ID' }: { children?: React.ReactNode }) => {
	const [hovered, setHovered] = useState(false)

	return (
		<Button
			onMouseEnter={() => setHovered(true)}
			onMouseLeave={() => setHovered(false)}
			data-testid='yandex-auth-button'
			variant='contained'
			onClick={async () => {
				await signIn('yandex', {
					callbackUrl: '/',
					redirect: false,
				})
			}}
			style={{ opacity: hovered ? 0.7 : 1 }}
			sx={{
				backgroundColor: '#1C1C1E',
				color: 'white',
				lineHeight: '20px',
				fontSize: '16px',
				fontWeight: '600px',
				borderRadius: '13px',
				textTransform: 'none',
				width: '100%',
				transition: 'all 0.3s ease-in-out',
				boxShadow: 'none',
				height: 50,
				'&:hover': {
					backgroundColor: '#1C1C1E',
					// opacity: 0.7,
					boxShadow: 'none',
				},
			}}
		>
			<Image src={'/svg/auth/yandex.svg'} alt={''} style={{ marginRight: 15 }} width={26} height={26} />
			{children}
		</Button>
	)
}
